import { AxiosResponse } from 'axios';
import { CurpPayload } from 'types/curp';
import { api } from './companiesApi';

export const generateLinkToUploadCandidates =
	async (): Promise<AxiosResponse> => {
		return await api.post('/candidates/csv-file');
	};

export const generateLinkToUploadEmployees =
	async (): Promise<AxiosResponse> => {
		return await api.post('/employees/csv-file');
	};

export const generateLinkToUploadResignationEmployees =
	async (): Promise<AxiosResponse> => {
		return await api.post('/employees/deactivate/csv-file');
	};

export const generateLinkToUploadCampaignFile = async (
	fileName: string,
): Promise<AxiosResponse> => {
	return await api.post('/campaigns/communications/file', {
		filename: fileName,
	});
};

export const getMeInfo = async (): Promise<AxiosResponse> => {
	return await api.get('/me');
};

export const getUserSettings = async (): Promise<AxiosResponse> => {
	return await api.get('/me/user-settings');
};

export const getAddressLocation = async (
	postalCode: string,
): Promise<AxiosResponse> =>
	await api.get(`/address?country=MX&postalCode=${postalCode}`);

export const getUrlQuicksightDashboard = async (
	isBroker: boolean,
): Promise<AxiosResponse> => {
	const url = isBroker
		? '/analytics/embeded?type=broker'
		: '/analytics/embeded';

	const response = await api.get(url);
	return response;
};

export const putUserSettings = async (data: any): Promise<AxiosResponse> => {
	return await api.put('/me/user-settings', data);
};

export const getUserReviews = async (): Promise<AxiosResponse> =>
	await api.get('/user-reviews');

export const putUserReview = async (
	userId: string,
	payload: any,
): Promise<AxiosResponse> => await api.put(`/user-reviews/${userId}`, payload);

export const getPdfOrders = async (id: string): Promise<AxiosResponse> => {
	return await api.get(`/appointments/${id}/service-request-file`);
};

export const postValidateCurp = async (payload: CurpPayload) => {
	return await api.post('/curp-validation', payload);
};

export const getNationalitiesCatalog = async () => {
	return await api.get('/catalogs/nationalities');
};

export const getCountriesCatalog = async () => {
	return await api.get('/catalogs/countries');
};

export const getFederalEntitiesCatalog = async () => {
	return await api.get('/catalogs/federal-entities');
};

export const getMunicipalitiesCatalog = async (federalEntityCode: number) => {
	return await api.get(
		`/catalogs/municipalities?federalEntityCode=${federalEntityCode}`,
	);
};

export const getLocationsCatalog = async (
	municipalityCode: number,
	federalEntityCode: number,
) => {
	return await api.get(
		`/catalogs/locations?municipalityCode=${municipalityCode}&federalEntityCode=${federalEntityCode}`,
	);
};
